export function polarNoise(angle, noiseDiameter, depth) {
  let xNoise = map(cos(angle), -1, 1, 0, noiseDiameter);
  let yNoise = map(sin(angle), -1, 1, 0, noiseDiameter);
  let zNoise = depth;
  return noise(xNoise, yNoise, zNoise);
}

export function randInt(min, max) {
  return floor(random(min, max + 1));
}

export function diceRoll(n) {
  return randInt(1, n);
}